import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "container",
  class: "main h-100 column gap-3 justify-content-center"
}
const _hoisted_2 = { class: "column gap-3 text-align-left" }
const _hoisted_3 = { class: "body xl font-bold" }
const _hoisted_4 = { class: "column gap-3 text-align-left" }
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "body" }

import NoAccountSection from '@/components/auth/NoAccountSection.vue';
import FormButton from '@/components/common/button/FormButton.vue';
import { useAuthFlow } from '@/composables/useAuthFlow';
import RouteNames from '@/configuration/router/names.routes';
import { spainAuthenticationEndpoints } from '@/core/endpoints';
import navigationService from '@/services/NavigationService';
import { useToasterStore } from '@/stores/useToasterStore';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpainAuth',
  setup(__props) {

const { t } = useI18n();
const toaster = useToasterStore();
const { processSpanishAuth } = useAuthFlow();
const loading = ref(false);

const navigateToNextScreen = async () => {
  const backendLoginUrl = `${process.env.VUE_APP_API_URL}${spainAuthenticationEndpoints.LOGIN}`;

  Office.context.ui.displayDialogAsync(
    backendLoginUrl,
    { height: 80, width: 80, promptBeforeOpen: false },
    (asyncResult) => {
      const dialog = asyncResult.value;
      loading.value = true;
      dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
        if ('message' in arg && arg.message.includes('ok')) {
          dialog.close();
          checkIfAuthenticated();
        }
      });
      dialog.addEventHandler(Office.EventType.DialogEventReceived, () => {
        dialog.close();
        loading.value = false;
      });
    }
  );
};

async function checkIfAuthenticated() {
  try {
    loading.value = true;

    const isAuthenticated = await processSpanishAuth();

    if (!isAuthenticated) throw new Error('Error authenticating the user');

    toaster.success({
      title: t('authentication.spain.success.title')
    });

    navigationService.navigateTo({ name: RouteNames.Home });
  } catch (err) {
    console.error(err);
    toaster.error({
      title: t('authentication.spain.error.title'),
      body: t('authentication.spain.error.body')
    });
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('welcome.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('welcome.ai_complement')), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('welcome.login_prompt')), 1)
    ]),
    _createVNode(FormButton, {
      label: _unref(t)('welcome.continue'),
      size: "large",
      onClick: navigateToNextScreen,
      "class-name": "w-100",
      disabled: loading.value
    }, null, 8, ["label", "disabled"]),
    _createVNode(NoAccountSection)
  ]))
}
}

})